<template>
  <div style="height: 300px; margin: auto;">
    <canvas id="overview-chart"></canvas>
  </div>
</template>

<script>
  import Chart from 'chart.js'

  export default {
    props: {
      chartData: {
        type: Object,
        required: true
      }
    },
    data: 
    {
      myChart : null
    },
    watch: {
      chartData (v) {
        this.createChart('overview-chart', v)
      }
    },
    methods: {
      createChart(chartId, chartData) {
        const ctx = document.getElementById(chartId);
        if(this.myChart != null)
        {
          this.myChart.destroy();
        }
        this.myChart = new Chart(ctx, {
          type: 'doughnut',
          data: chartData,
          options : {
            responsive: true,
            maintainAspectRatio: false
          }
        });
      }
    },
    mounted() {
      this.createChart('overview-chart', this.chartData)
    }
  }
</script>
